module.exports = __webpack_public_path__ + "b4a8b667686a9b56fc2fff57b9c2a703.png";